// extracted by mini-css-extract-plugin
export var colorSquare = "_rk-0";
export var danger = "_rk-5";
export var lightPink = "_rk-8";
export var neutralBlue = "_rk-7";
export var neutralYellow = "_rk-6";
export var normal = "_rk-1";
export var primary = "_rk-2";
export var primaryLight = "_rk-3";
export var solidBlack = "_rk-g";
export var solidGreen = "_rk-b";
export var solidLightBlue = "_rk-d";
export var solidNavy = "_rk-c";
export var solidOrange = "_rk-f";
export var solidPink = "_rk-e";
export var solidRed = "_rk-9";
export var solidYellow = "_rk-a";
export var success = "_rk-4";